module.exports = __webpack_public_path__ + "static/media/img_landing07.57092ad6.png";